module.exports = __webpack_public_path__ + "static/media/sw-bg.dff75a1f.jpg";